import { NgModule } from '@angular/core';
import { CompatLocalStorageComponent } from './compat-local-storage.component';

@NgModule({
  declarations: [CompatLocalStorageComponent],
  entryComponents: [CompatLocalStorageComponent],
})
export class CompatLocalStorageModule {}
